const workflow = [
  {
    number: "01",
    title: "Elige lo que necesitas repasar",
    description: "Navega por área, especialidad y tema clínico.",
  },
  {
    number: "02",
    title: "Decide qué fuente consultar",
    description: "Combina el banco completo o enfócate solo en PRONAM, GPC u otra fuente.",
  },
  {
    number: "03",
    title: "Practica y vuelve a lo débil",
    description: "Alterna flashcards, simuladores y repaso espaciado según tu avance.",
  },
];

export function WorkflowSection() {
  return (
    <section id="como-funciona" className="py-20 lg:py-28">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase text-primary">Cómo funciona</p>
          <h2 className="mt-3 text-3xl font-bold sm:text-4xl lg:text-5xl">Una sesión útil empieza con una decisión clara</h2>
        </div>
        <div className="mt-12 grid gap-px bg-border lg:grid-cols-3">
          {workflow.map((item) => (
            <article key={item.number} className="min-h-64 bg-background p-7 sm:p-9">
              <p className="font-mono text-sm font-bold text-primary">{item.number}</p>
              <h3 className="mt-12 text-xl font-bold">{item.title}</h3>
              <p className="mt-3 leading-relaxed text-muted-foreground">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
